import {ShapeCommand} from '../commands.template';
import {v4 as uuidv4} from 'uuid';

export class ResourceChangePerRowCommand extends ShapeCommand {
  protected services;
  resourcesPerRow: number;
  firstAction: boolean;
  mxKey: number;
  reverseData: any;

  id = uuidv4();

  constructor(data) {
    super(data);
    this.resourcesPerRow = Number(this.object.resourcesPerRow);
    this.mxKey = Number(this.object.mxKey);
    this.firstAction = true;
  }

  public prepareData() {
    const cell = this.services.registry.getGraph().getModel().getCell(this.mxKey);
    const {resourcesPerRow = 0} = cell.getJson();

    this.reverseData = {
      mxKey: this.mxKey,
      resourcesPerRow
    };

    return this;
  }

  public execute(): any {
    super.execute();
    const action = {mxKey: this.mxKey, resourcesPerRow: this.resourcesPerRow};

    this.performUpdate(action);
  }

  public reverse(): any {
    super.reverse();
    this.performUpdate({...this.reverseData});
  }

  private performUpdate(data) {
    const model = this.services.registry.getGraph().getModel();
    const cell = model.getCell(Number(this.mxKey));

    model.beginUpdate();
    cell.skipUndo = true;
    this.services.resourceSvc.recalcActivitySize(cell, cell.getJson(), {
      rowSize: data.resourcesPerRow,
      deltaKey: this.id
    });
    this.services.diagramUpdateSvc.update({changeResourcesPerRow: {...data}});
    model.endUpdate();
    this.redrawActivity(this.mxKey);
  }

  private redrawActivity(activityMxKey) {
    this.services.editorRegistrySvc
      .getGraph()
      .model.getCell(Number(activityMxKey))
      .comp.instance.setupFromJson();
  }
}
